import React, { useState } from "react";
import HeaderTemplates from "./components/HeaderTemplates";
import MealPlanTemplates from "./components/MealPlanTemplates";
import ProgramsTemplates from "./components/ProgramsTemplates";

const AllTemplatesView = (props, context) => {
  const { locals } = context;
  const { cards, activeUser, mealPlanTemplates, query } = locals;
  const { tabView } = query;
  const referAsClients = Boolean(activeUser.referAsClients);
  const { total, pageSize } = props;
  const initialViewState = tabView ? tabView : "programs-tab";
  const [tabState, setTabState] = useState(initialViewState); //state to control the active tab
  const isInPrograms = tabState === "programs-tab";
  const templates = isInPrograms ? cards : mealPlanTemplates;
  const descriptionText =
    tabState === "programs-tab"
      ? `Build templated programs that you can repurpose to save time. Send templates directly to ${
          referAsClients ? "clients" : "athletes"
        }, or make copies of them to modify and individualize.`
      : `Create meal plan templates you can reuse and customize before sending to ${
          referAsClients ? "clients" : "athletes"
        } saving time while keeping plans personal.`;

  return (
    <main className="coaching-programs">
      <input type="checkbox" id="mobile-filter-toggle" />
      <HeaderTemplates
        referAsClients={referAsClients}
        tabState={tabState}
        setTabState={setTabState}
      />

      {templates && Array.isArray(templates) && templates.length > 0 ? (
        isInPrograms ? (
          <ProgramsTemplates
            locals={locals}
            cards={cards}
            total={total}
            pageSize={pageSize}
          />
        ) : (
          <MealPlanTemplates locals={locals} templates={mealPlanTemplates} />
        )
      ) : (
        <div className="no-programs-section">
          <p>No Templates Added</p>
          <span>{descriptionText}</span>
          <a
            role="button"
            data-button-type="primary"
            href={
              isInPrograms
                ? `/actions/refresh/?modal[type]=build-step-one&cycleType=new&isTemplate=true`
                : `/actions/refresh/?modal[type]=handle-meal-plan`
            }
          >
            Add Template
          </a>
        </div>
      )}
    </main>
  );
};

export default AllTemplatesView;
